import { Navigate } from 'react-router-dom';
export const PrivateRoute = ({ session, sessionLoading, allowedRoles, children }) => {
  if (sessionLoading) return null;
  if (!session) return <Navigate to="/" replace />;

  if (allowedRoles && !allowedRoles.includes(session.role)) {
    if (session.role === 'platform_admin') {
      return <Navigate to="/admin" replace />;
    }
    if (session.org_id) {
      return <Navigate to={`/client/${session.org_id}/dashboard`} replace />;
    }
    return <Navigate to="/no-role" replace />;
  }

  return children;
};
